import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Printer, ListOrdered } from "lucide-react";
import { toast } from "sonner";
import { MTopBar } from "@/components/mobile/MTopBar";
import { MPage, SearchBox, Loading, EmptyArt, Chip, cardCls } from "@/components/mobile/parts";
import { usePoll } from "@/hooks/useMobileData";
import { api, brl, errMsg, fmtTime } from "@/lib/api";
import { norm, sendPrint } from "@/lib/mobile";
import { cn } from "@/lib/utils";

const label = (o) => `${o.table_number ? `Mesa ${o.table_number} · ` : ""}Comanda #${o.comanda_number}`;

function OrderCard({ o }) {
  const nav = useNavigate();
  const reprint = (e) => {
    e.stopPropagation();
    const items = o.items.filter((i) => i.status !== "cancelled").map(({ name, qty, notes }) => ({ name, qty, notes }));
    sendPrint("order", `2ª via · Pedido ${o.number} · ${label(o)}`, { order: { number: o.number, at: o.at, user: o.user, pickup_number: o.pickup_number, label: label(o), items, sectors: [] }, reprint: true })
      .then(() => toast.success("Enviado para a impressora do caixa")).catch((err) => toast.error(errMsg(err)));
  };
  return (
    <div role="button" tabIndex={0} onClick={() => nav(`/m/comanda/${o.comanda_id}`)} className={cn(cardCls, "space-y-2 p-4", o.cancelled && "opacity-60")} data-testid={`m-day-order-${o.comanda_number}-${o.number}`}>
      <div className="flex items-start gap-2">
        <div className="flex-1">
          <p className="font-semibold">{label(o)} · Pedido {o.number}</p>
          <p className="text-xs text-slate-500">{fmtTime(o.at)} · {o.user}{o.customer_name ? ` · ${o.customer_name}` : ""}</p>
        </div>
        {o.cancelled ? <Chip tone="red">Cancelado</Chip> : o.comanda_status !== "open" ? <Chip tone="green">Comanda fechada</Chip> : <Chip tone="blue">Aberta</Chip>}
      </div>
      <p className="text-sm text-slate-700">{o.items.map((i) => `${i.qty}x ${i.name}`).join(", ")}</p>
      <div className="flex items-center justify-between">
        <button onClick={reprint} className="flex items-center gap-1 text-xs font-semibold text-[#1565c0]" data-testid={`m-day-order-reprint-${o.comanda_number}-${o.number}`}><Printer className="h-4 w-4" />Reimprimir</button>
        <span className="font-mono font-bold">{brl(o.total)}</span>
      </div>
    </div>
  );
}

export default function MOrders() {
  const { data } = usePoll(() => api.get("/mobile/orders").then((r) => r.data), 15000);
  const [q, setQ] = useState("");
  const s = norm(q);
  const shown = (data || []).filter((o) => !s || String(o.comanda_number).startsWith(s) || norm(o.customer_name).includes(s) || norm(o.user).includes(s));
  return (
    <>
      <MTopBar title="Pedidos de hoje" />
      <MPage>
        <SearchBox value={q} onChange={setQ} placeholder="Buscar por comanda, cliente ou garçom" testId="m-orders-search" />
        {!data ? <Loading /> : !data.length ? <EmptyArt icon={ListOrdered} title="Nenhum pedido hoje" text="Os pedidos lançados nas comandas aparecem aqui." testId="m-day-orders-empty" /> : (
          <div className="space-y-2.5" data-testid="m-day-orders">{shown.map((o) => <OrderCard key={`${o.comanda_id}-${o.id}`} o={o} />)}</div>
        )}
      </MPage>
    </>
  );
}
